import Sidebar from "../../../components/Navigation/Sidebar"
import SidebarButton from "../../../components/Navigation/SidebarButton"
import { AdjudicationsTabType } from "../../../Store/Navigation/state"

interface IAdjudicationsSidebarProps {
    setTab: (type: AdjudicationsTabType) => void
    activeTab: AdjudicationsTabType
}

const AdjudicationsSidebar: React.FC<IAdjudicationsSidebarProps> = (props) => {
    return (
        <Sidebar>
            <SidebarButton
                tab={AdjudicationsTabType.ONCOMING}
                setTab={props.setTab}
                activeTab={props.activeTab === AdjudicationsTabType.ONCOMING}
            >
                Oncoming
            </SidebarButton>
            <SidebarButton
                tab={AdjudicationsTabType.PENDING}
                setTab={props.setTab}
                activeTab={props.activeTab === AdjudicationsTabType.PENDING}
            >
                Pending
            </SidebarButton>
            <SidebarButton
                tab={AdjudicationsTabType.SOLVED}
                setTab={props.setTab}
                activeTab={props.activeTab === AdjudicationsTabType.SOLVED}
            >
                Solved
            </SidebarButton>
        </Sidebar>
    )
}

export default AdjudicationsSidebar